import { PaymentsReportActionTypes } from "./actionTypes";

export const getTransactions = (payload) => {
  return {
    type: PaymentsReportActionTypes.PROFREPORTS_LIST_GET,
    payload: payload,
  };
};
export const getTransactionsSuccessful = (payload) => {
  return {
    type: PaymentsReportActionTypes.PROFREPORTS_LIST_GET_SUCCESSFUL,
    payload: payload,
  };
};
export const getTransactionsError = (payload) => {
  return {
    type: PaymentsReportActionTypes.PROFREPORTS_LIST_GET_ERROR,
    payload,
  };
};


export const getInvoices = (payload) => {
  return {
    type: PaymentsReportActionTypes.PROFREPORT_LIST_GET,
    payload: payload,
  };
};
export const getInvoicesSuccessful = (payload) => {
  return {
    type: PaymentsReportActionTypes.PROFREPORT_LIST_GET_SUCCESSFUL,
    payload: payload,
  };
};
export const getInvoicesError = (payload) => {
  return {
    type: PaymentsReportActionTypes.PROFREPORT_LIST_GET_ERROR,
    payload,
  };
};


export const getFilteredTransactions = (payload) => {
  return {
    type: PaymentsReportActionTypes.PROFREPORTS_GET_FILTERED,
    payload: payload,
  };
};
export const getFilteredTransactionsSuccessful = (payload) => {
  return {
    type: PaymentsReportActionTypes.PROFREPORTS_GET_FILTERED_SUCCESSFUL,
    payload: payload,
  };
};
export const getFilteredTransactionsError = (payload) => {
  return {
    type: PaymentsReportActionTypes.PROFREPORTS_GET_FILTERED_ERROR,
    payload,
  };
};




export const createInvoice = (transaction) => {
  return {
    type: PaymentsReportActionTypes.PROFREPORTS_CREATE,
    payload: transaction,
  };
};
export const createInvoiceSuccess = (transaction) => {
  return {
    type: PaymentsReportActionTypes.PROFREPORTS_CREATE_SUCCESS,
    payload: transaction,
  };
};
export const createInvoiceError = (transaction) => {
  return {
    type: PaymentsReportActionTypes.PROFREPORTS_CREATE_ERROR,
    payload: transaction,
  };
};
